var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { attrs: { flat: "" } },
    [
      _c(
        "v-card-title",
        [
          _c("h3", [_vm._v("Realtime Data Feed")]),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: { text: "", icon: "", color: "grey lighten-1" },
              on: { click: _vm.refresh },
            },
            [_c("v-icon", [_vm._v("fas fa-sync")])],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("v-data-table", {
        staticClass: "elevation-1",
        attrs: {
          items: _vm.systemRTLogs,
          loading: _vm.loading,
          headers: _vm.headers,
          options: _vm.pagination,
          "server-items-length": _vm.totalItems,
        },
        on: {
          "update:options": function ($event) {
            _vm.pagination = $event
          },
        },
        scopedSlots: _vm._u([
          {
            key: "items",
            fn: function (props) {
              return [
                _c("td", [
                  _vm._v(_vm._s(_vm.formatDateTime(props.item.receivedTime))),
                ]),
                _vm._v(" "),
                _c(
                  "td",
                  [
                    _c(
                      "v-flex",
                      { attrs: { "pl-1": "", "pr-1": "" } },
                      [
                        _c("v-textarea", {
                          staticStyle: { "font-size": "small" },
                          attrs: { readonly: "", label: "" },
                          model: {
                            value: props.item.value,
                            callback: function ($$v) {
                              _vm.$set(props.item, "value", $$v)
                            },
                            expression: "props.item.value",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  [
                    _c(
                      "v-btn",
                      {
                        attrs: { text: "", icon: "" },
                        on: {
                          click: function ($event) {
                            return _vm.doCopy(props.item.value)
                          },
                        },
                      },
                      [_c("v-icon", [_vm._v("file_copy")])],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }